export default "__VITE_ASSET__93e8ef59__"